import Select from 'react-select';
import React, { useEffect, useState } from 'react';
import {
  InputGroup,
  Card,
  ToggleButton,
  FormControl,
  ToggleButtonGroup,
  Button,
  Modal,
  Accordion,
} from "react-bootstrap";
import { Container, Row, Col } from 'react-bootstrap';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import SignalSelect from "./SignalSelect";
import SWColourPicker from "../sw-colourpicker";
import { Chart, registerables } from 'chart.js';
import 'chartjs-adapter-moment';
import zoomPlugin from 'chartjs-plugin-zoom';
import annotationPlugin from 'chartjs-plugin-annotation';
import $ from 'jquery';
import moment from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css'
import { useTranslation } from 'react-i18next';


Chart.register(...registerables);
Chart.register(zoomPlugin);
Chart.register(annotationPlugin);

const optionsDP = [
    { value: 1, label: "1" },
    { value: 2, label: "2" },
    { value: 3, label: "3" },
    { value: 4, label: "4" },
    { value: 5, label: "5" },
];

const colorPickerColours = ['#14a8de', '#a0512d', '#944ba3', '#069416', '#002b4f', '#f47920', '#101820'];

var defaultAxisInfo = { id: 1, label: "", position: "left", ttDP: 3, options: [], selectedColourIdx: 0 };

let chart;

const selectStyles = {
    menuPortal: base => ({ ...base, zIndex: 9998 }),
    menu: provided => ({ ...provided, zIndex: "9998 !important" })
};

function CustomGraphModal(props) {
    const { t } = useTranslation();
    const [stage, setStage] = useState(0);
    const [start, setStart] = useState(moment().subtract(7, 'days'));
    const [end, setEnd] = useState(moment());
    const [signals, setSignals] = useState([]);
    const [datasets, setDatasets] = useState([]);
    const [counter, setCounter] = useState(0);
    const [axisInfo, setAxisInfo] = useState([]);
    const [accordionActiveKey, setAccordionActiveKey] = useState("1");
    const [siteGUID] = useState(props.siteGUID);
    //const [chart, setChart] = useState();
    const [imageURL, setImageURL] = useState();

    useEffect(() => {
        $.ajax(
            {
                url: '/api/DataExplorationAPI/GetSiteSignals/',
                type: 'get',
                data: { site: siteGUID },
                success: function (response) {
                    // set default options list 
                    var options = response.value;
                    options.map(option => option.isDisabled = 0);
                    options.map(option => option.isSelected = 0);
                    options.map(option => option.selectedColour = 'rgba(20, 168, 222, 0.8)');
                    defaultAxisInfo.options = options;

                    // Update axis 1 with default options
                    var curAxisInfo = axisInfo;
                    var newAxisInfo = JSON.parse(JSON.stringify(defaultAxisInfo));
                    curAxisInfo.push(newAxisInfo);

                    setAxisInfo(curAxisInfo);
                }.bind(this)
            }
        );
    }, []);

    useEffect(() => {
        let eles = document.querySelectorAll('[role="dialog"]');
        eles.forEach(function (el) {
            el.removeAttribute('tabindex')
        });
        if (stage === 0) {
            //$(this.daterange.current).daterangepicker(
            //    function (start, end, label) {
            //        this.setState({ start: start, end: end });
            //        var printStart = start.format();
            //        var printEnd = end.format();
            //        console.log('New date range selected: ' + printStart + ' to ' + printEnd + ' (predefined range: ' + label + ')');
            //    }.bind(this)
            //);

        } else if (stage === 1) {

        } else if (stage == 2) {
            var data = {};
            // Remove empty datasets (SignalData requests that failed)
            data.datasets = datasets.filter(function (dataset) {
                return dataset != null;
            });

            // Generate y axes from user selections
            var yAxes = {};
            for (var i = 0; i < axisInfo.length; i++) {
                var id = 'y' + axisInfo[i].id;
                var yAxis = {
                    id: axisInfo[i].id,
                    type: 'linear',
                    display: true,
                    position: axisInfo[i].position,
                    title: {
                        display: true,
                        text: axisInfo[i].label
                    },
                };
                yAxes[id] = yAxis;
            }

            const dateTimeFormatLong = 'DD/MM/YY h:mm a';
            const dateTimeFormatShort = 'DD/MM/YY';
            var config = {
                type: 'line',
                data: data,
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    tooltips: {
                        mode: 'nearest',
                        intersect: false,
                        position: 'average',
                        callbacks: {
                            label: function (tooltipItem, data) {
                                var label = tooltipItem.xLabel || '';
                                var axisID = data.datasets[tooltipItem.datasetIndex].yAxisID;
                                var idx = getAxisIndex(axisID, axisInfo);

                                var nDecimalPlaces = axisInfo[idx].ttDP;
                                var dpFactor = Math.pow(10, nDecimalPlaces);


                                if (label) {
                                    label += ' | ';
                                }

                                label += data.datasets[tooltipItem.datasetIndex].label + ": " + (Math.round(tooltipItem.yLabel * dpFactor) / dpFactor).toFixed(nDecimalPlaces);
                                return label;
                            }.bind(this)
                        }
                    },
                    hover: {
                        mode: 'nearest',
                        intersect: false
                    },
                    scales: {
                        xAxis: {
                            position: 'bottom',
                            type: 'time',
                            ticks: {
                                maxTicksLimit: 20
                            },
                            display: true,
                            scaleLabel: {
                                display: true,
                                labelString: 'Time'
                            },
                            time: {
                                displayFormats: {
                                    'millisecond': dateTimeFormatLong,
                                    'second': dateTimeFormatLong,
                                    'minute': dateTimeFormatLong,
                                    'hour': dateTimeFormatLong,
                                    'day': dateTimeFormatShort,
                                    'week': dateTimeFormatShort,
                                    'month': dateTimeFormatShort,
                                    'quarter': dateTimeFormatShort,
                                    'year': dateTimeFormatShort,
                                },
                                tooltipFormat: dateTimeFormatLong
                            }
                        },
                        ...yAxes
                    },
                    plugins: {
                        zoom: {
                            pan: {
                                enabled: true,
                                modifierKey: 'ctrl'
                            },
                            zoom: {
                                mode: 'x',
                                wheel: {
                                    enabled: true
                                },
                                drag: {
                                    enabled: true
                                }
                            },
                        }
                    },
                    animation: {
                        onComplete: saveImage
                    },
                }
            };

            var ctx = document.getElementById('customgraphcanvas').getContext('2d');
            if (chart) chart.destroy();
            chart = new Chart(ctx, config);
            setStage(3);
        } else if (stage === 3) {
            // Wait for click of back button
        }
    }, [stage,start,end,axisInfo,datasets]);

    const resetZoom = () => {
        chart.resetZoom();
    };

    const saveImage = () => {
        if (chart) {
            setImageURL(chart.toBase64Image());
        }
    };

    const backClickHander = () => {
        setStage(0);
        setCounter(0);
    };

    const createClickHandler = () => {
        function updatedataset(dataset, i) {
            var currentdatasets = datasets;
            currentdatasets[i] = dataset;
            setDatasets(currentdatasets);
        }

        var updateDataSetBound = updatedataset.bind(this);

        for (var i = 0; i < signals.length; i++) {
            (function (i) {
                $.ajax({
                    url: '/api/DataExplorationAPI/GetSignalData/',
                    type: 'get',
                    data: { SignalID: signals[i]["value"], startTime: moment.utc(start).format(), endTime: moment.utc(end).format() },
                    success: function (response) {
                        var data = [];
                        var j;
                        for (j = 0; j < response.length; j++) {
                            var newData = { x: moment(response[j].t), y: response[j].v };
                            data.push(newData);
                        }

                        var dataset = {
                            label: signals[i]["label"],
                            borderColor: signals[i].colour,
                            data: data,
                            type: 'line',
                            pointRadius: 1.75,
                            fill: false,
                            tension: 0.1,
                            yAxisID: 'y' + signals[i].axisID
                        };

                        updateDataSetBound(dataset, i);

                        if (counter === signals.length - 1) { // Only progress to stage 2 once all ajax requests complete
                            setStage(2);
                        } else {
                            setCounter(counter + 1 );
                        };

                    }.bind(this),
                    error: function (jqXHR, textStatus, errorThrown) {
                        console.log("Error Receiving Signal Data");
                        console.log(textStatus);
                        console.log(errorThrown);

                        // Insert empty dataset
                        updateDataSetBound(undefined, i);

                        if (counter === signals.length - 1) { // Only progress to stage 2 once all ajax requests complete
                            setStage(2);
                        } else {
                            setCounter(counter + 1 );
                        };
                    }.bind(this)
                });
            }.bind(this))(i);
        }
    }

    const addAxisClickHandler = () => {
        var newAxisInfo;
        if (axisInfo.length > 0) {
            newAxisInfo = JSON.parse(JSON.stringify(axisInfo[axisInfo.length - 1])); // Initialise axis info to last added axis
            newAxisInfo.id = axisInfo[axisInfo.length - 1].id + 1; // New axis should have ID + 1 of last axis
        } else {
            newAxisInfo = JSON.parse(JSON.stringify(defaultAxisInfo));
        }
        // Reset all options to not selected.
        for (var i = 0; i < newAxisInfo.options.length; i++) {
            newAxisInfo.options[i].isSelected = 0;
        }

        var curAxisInfo = Object.assign([], axisInfo);
        curAxisInfo.push(newAxisInfo);
        setAxisInfo(curAxisInfo);
        setAccordionActiveKey(newAxisInfo.id.toString());
    }

    function getAxisIndex(axisID, axisInfo) {
        var idx;
        for (var j = 0; j < axisInfo.length; j++) {
            if (axisInfo[j].id === axisID) {
                idx = j;
                break;
            }
            idx = -1;
        };
        return idx;
    }


    function handleChange(axisID, e) {
        // Get axis info index from id
        var idx = getAxisIndex(axisID, axisInfo);
        var curAxisInfo = Object.assign([], axisInfo);

        // For each option for this axis
        // if in selectList & isSelected = 0: set isSelected = 1 for this option in this axis, set selectedColour for this option as current selected colour
        // ,set isDisabled = 1 for this option in all axes'
        // if in selectList & isSelected = 1: set isDisabled = 1 for this option in all axes'
        // if not in selectList & isSelected = 1: set isSelected = 0 for this option in this axis, isDisabled = 0 for this option in all axes'
        // if not in selectList & isSelected = 0: do nothing

        if (e && e.length > 0) { // There are selected options to check
            loop1:
            for (var i = 0; i < curAxisInfo[idx].options.length; i++) {
                loop2:
                for (var j = 0; j < e.length; j++) {
                    if (e[j]["value"] === curAxisInfo[idx].options[i]["value"]) { // option is in selectList
                        if (!curAxisInfo[idx].options[i].isSelected) { // This option was not previously selected
                            curAxisInfo[idx].options[i].selectedColour = colorPickerColours[axisInfo[idx].selectedColourIdx];
                        }
                        // set isSelected = 1 for this option in this axis,
                        curAxisInfo[idx].options[i].isSelected = 1;
                        //  set isDisabled = 1 for this option in all axes'
                        for (var k = 0; k < curAxisInfo.length; k++) {
                            curAxisInfo[k].options[i].isDisabled = 1;
                        }
                        continue loop1; // don't need to check any other options
                    }
                }
                // option is NOT in selectList
                if (curAxisInfo[idx].options[i].isSelected) { // option was previously selected
                    // set isSelected = 0 for this option in this axis, 
                    curAxisInfo[idx].options[i].isSelected = 0;
                    // set isDisabled = 0 for this option in all axes'
                    for (var k = 0; k < curAxisInfo.length; k++) {
                        curAxisInfo[k].options[i].isDisabled = 0;
                    }
                } else { // option was NOT previously selected
                    // do nothing
                }
            }
        } else { // no selected options (user just cleared select list)
            for (var i = 0; i < curAxisInfo[idx].options.length; i++) {
                if (curAxisInfo[idx].options[i].isSelected) { // option was previously selected
                    // set isSelected = 0 for this option in this axis, 
                    curAxisInfo[idx].options[i].isSelected = 0;
                    // set isDisabled = 0 for this option in all axes'
                    for (var k = 0; k < curAxisInfo.length; k++) {
                        curAxisInfo[k].options[i].isDisabled = 0;
                    }
                } else { // option was NOT previously selected
                    // do nothing
                }
            }
        }

        var newSignals = [];

        // Update signal list (used for retrieving data)
        for (var i = 0; i < curAxisInfo.length; i++) {
            for (var j = 0; j < curAxisInfo[i].options.length; j++) {
                if (curAxisInfo[i].options[j].isSelected) {
                    var signal = {
                        label: curAxisInfo[i].options[j].label,
                        value: curAxisInfo[i].options[j].value,
                        axisID: curAxisInfo[i].id,
                        colour: curAxisInfo[i].options[j].selectedColour
                    };
                    newSignals.push(signal);
                }
            }
        }

        // Update axis info state
        setAxisInfo(curAxisInfo);

        if (axisInfo[idx].selectedColourIdx < colorPickerColours.length - 1) {
            curAxisInfo[idx].selectedColourIdx++;
            setSignals(newSignals);
            setAxisInfo(curAxisInfo);
        } else {
            curAxisInfo[idx].selectedColourIdx = 0;
            setSignals(newSignals);
            setAxisInfo(curAxisInfo);
        }
    }

    function handleDPchange(axisID, e) {
        var idx = getAxisIndex(axisID, axisInfo);
        var curAxisInfo = Object.assign([], axisInfo);
        curAxisInfo[idx].ttDP = e["value"];
        setAxisInfo(curAxisInfo);
    }

    function leftAxisClickHandle(axisID, e) {
        var idx = getAxisIndex(axisID, axisInfo);
        var curAxisInfo = Object.assign([], axisInfo);
        curAxisInfo[idx].position = "left";
        setAxisInfo(curAxisInfo);
    };

    function rightAxisClickHandle(axisID, e) {
        var idx = getAxisIndex(axisID, axisInfo);
        var curAxisInfo = Object.assign([], axisInfo);
        curAxisInfo[idx].position = "right";
        setAxisInfo(curAxisInfo);
    }

    function handleYAxisLabelChange(axisID, e) {
        var idx = getAxisIndex(axisID, axisInfo);
        var curAxisInfo = Object.assign([], axisInfo);
        curAxisInfo[idx].label = e.target.value;
        setAxisInfo(curAxisInfo);
    }

    function removeAxisClickHandler(axisID) {
        var idx = getAxisIndex(axisID, axisInfo);
        var curAxisInfo = Object.assign([], axisInfo);
        // In all of the other axes, re-enable the options that were selected in this axis.
        for (var i = 0; i < curAxisInfo[idx].options.length; i++) {
            if (curAxisInfo[idx].options[i].isSelected) {
                for (var j = 0; j < curAxisInfo.length; j++) {
                    curAxisInfo[j].options[i].isDisabled = 0;
                }
            }
        }
        curAxisInfo.splice(idx, 1);
        // Set accordion active key to last axis
        var newActiveID = accordionActiveKey;
        if (curAxisInfo.length > 0) {
            newActiveID = curAxisInfo[curAxisInfo.length - 1].id.toString();
        }
        // Remove signals that were assigned to this axis
        var curSignals = Object.assign([], signals);
        var filteredSignals = curSignals.filter(signal => signal.axisID !== axisID);
        console.log(filteredSignals);
        setSignals(filteredSignals);
        setAxisInfo(curAxisInfo);
        setAccordionActiveKey(newActiveID);
    }

    function handleColourChange(axisID, color) {
        var idx = getAxisIndex(axisID, axisInfo);
        var curAxisInfo = Object.assign([], axisInfo);
        for (var i = 0; i < colorPickerColours.length; i++) {
            if (color.hex === colorPickerColours[i]) {
                curAxisInfo[idx].selectedColourIdx = i;
                setAxisInfo(curAxisInfo);
                break;
            }
        }
    }

    const resetClickHandler = () => {
        var freshAxisInfo = [];
        freshAxisInfo.push(JSON.parse(JSON.stringify(defaultAxisInfo)));
        setStage(0);
        setSignals([]);
        setStart(moment().subtract(7, 'days'));
        setEnd(moment());
        setCounter(0);
        setAxisInfo(freshAxisInfo);
        setAccordionActiveKey("1");
    }

    function renderAxisCard(axisID) {
        var idx = getAxisIndex(axisID, axisInfo);
        var thisEventKey = axisID.toString();
        return (
            <Accordion.Item key={axisID} eventKey={thisEventKey} >
                <Accordion.Header style={{ cursor: 'pointer' }} onClick={() => setAccordionActiveKey(thisEventKey)}>
                    <div style={{width: "100%", display: 'flex', justifyContent: 'space-between', paddingRight: '15px'}}>
                        <h4 className="align-items-center verticalalign"> {t("components.linecharts.dataexploration.axis")} {[axisID]} </h4>
                        <div className="float-right">
                            <Button className="pull-right" variant="danger" size="sm" onClick={() => removeAxisClickHandler(axisID)}>
                                <i className="justify-content-end" class="fas fa-times"></i>
                            </Button>
                        </div>
                    </div>
                </Accordion.Header>
                <Accordion.Body eventKey={thisEventKey}>
                    <div className="p-2">{t("components.linecharts.dataexploration.body-instructions")}</div>
                    
                    <SWColourPicker
                        colorPickerColours={colorPickerColours}
                        color={colorPickerColours[axisInfo[idx].selectedColourIdx]}
                        handleColourChange={handleColourChange.bind(this, axisID)}
                    />

                    <InputGroup className="p-2">
                        <InputGroup.Text id="inputGroup-sizing-default">{t("components.linecharts.dataexploration.signals")}</InputGroup.Text>
                        <div style={{ width: 'calc(100% - 98px)' }}>
                            <SignalSelect
                                options={axisInfo[idx].options}
                                onChange={handleChange.bind(this, axisID)}
                                value={axisInfo[idx].options.filter(option => option.isSelected == 1)}
                            />
                        </div>
                    </InputGroup>

                    <InputGroup className="p-2">
                        <InputGroup.Text id="inputGroup-sizing-default">{t("components.linecharts.dataexploration.y-axislabel")}</InputGroup.Text>
                        <FormControl
                            aria-label="Default"
                            aria-describedby="inputGroup-sizing-default"
                            onChange={handleYAxisLabelChange.bind(this, axisID)}
                            value={axisInfo[idx].label}
                            placeholder="Enter label"
                        />
                    </InputGroup>

                    <Container className="p-2">
                        <Row>
                            <Col>
                                <InputGroup>
                                    <InputGroup.Text id="inputGroup-sizing-default">{t("components.linecharts.dataexploration.decimalplaces")}</InputGroup.Text>
                                    <div style={{ width: 'calc(100% - 273px)' }}>
                                        <Select
                                            options={optionsDP}
                                            value={optionsDP[optionsDP.map(function (e) { return e.value }).indexOf(axisInfo[idx].ttDP)]}
                                            className="basic-single"
                                            classNamePrefix="select"
                                            name="decimalPlaces"
                                            onChange={handleDPchange.bind(this, axisID)}
                                            menuPortalTarget={document.querySelector('body')}
                                            styles={selectStyles}
                                        />
                                    </div>
                                </InputGroup>
                            </Col>
                            <Col>
                                <InputGroup>
                                    <InputGroup.Text id="inputGroup-sizing-default">{t("components.linecharts.dataexploration.axislabelside")}</InputGroup.Text>
                                    <ToggleButtonGroup type="radio" aria-label="Basic example" name="PositionSelect" className="btn-block" value={axisInfo[idx].position}>
                                        <ToggleButton value="left" variant="secondary" onClick={leftAxisClickHandle.bind(this, axisID)}>{t("common.left")}</ToggleButton>
                                        <ToggleButton value="right" variant="secondary" onClick={rightAxisClickHandle.bind(this, axisID)}>{t("common.right")}</ToggleButton>
                                    </ToggleButtonGroup>
                                </InputGroup>
                            </Col>
                        </Row>
                    </Container>
                </Accordion.Body>
            </Accordion.Item>
        );
    }

    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip"  {...props} >
            <div>{t("components.linecharts.dataexploration.button-tooltip")}</div>
        </Tooltip>
    );

    const handleDatetimerangeUpdate = (start, end, label) => {
        setStart(start);
        setEnd(end);
        var printStart = start.format();
        var printEnd = end.format();
        console.log('New date range selected: ' + printStart + ' to ' + printEnd + ' (predefined range: ' + label + ')');
    }

    return (
        <Modal
            {...props}
            centered
            id={props.label}
            role="dialog"
            aria-labelledby={props.label}
            aria-hidden="true"
            dialogClassName="modal-90w"
        >
            {stage == 0 ?
                <>
                    <Modal.Header>
                        <Modal.Title style={{ display: 'flex', width: "100%" }}>
                            <h3 className="p-2 align-items-center verticalalign">{t("components.linecharts.dataexploration.customgraph")}</h3>
                            <div className="p-2" style={{ 'marginLeft': 'auto' }}>
                                <Button className="btn btn-primary text-light" onClick={resetClickHandler}><i className="fas fa-redo"></i>  {t("components.linecharts.dataexploration.reset")}</Button>
                                <>   </>
                                <OverlayTrigger
                                    placement="bottom-end"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={renderTooltip}
                                >
                                    <Button variant="primary"><i className="fas fa-question"></i></Button>
                                </OverlayTrigger>
                            </div>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            <div id="dataExplorationDateRangePicker" className="card m-2">
                                <div className="card-body p-0">
                                    <div className="input-group">
                                        <div className="d-none d-lg-block d-xl-block bg-primary p-3 text-light"><i className="far fa-2x fa-calendar-alt"></i></div>
                                        <DateRangePicker
                                            onCallback={handleDatetimerangeUpdate}
                                            initialSettings={{
                                                timePicker: true,
                                                autoApply: true,
                                                ranges: {
                                                    'Last 24 hours': [moment().subtract(1, 'days'), moment()],
                                                    'Yesterday': [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
                                                    'Last 7 Days': [moment().subtract(7, 'days'), moment()],
                                                    'Last 30 Days': [moment().subtract(30, 'days'), moment()],
                                                    'This Month': [moment().startOf('month'), moment().endOf('month')],
                                                    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                                                },
                                                alwaysShowCalendars: true,
                                                maxDate: moment(),
                                                startDate: start,
                                                endDate: end,
                                                opens: "center",
                                                locale: {
                                                    format: 'DD/MM/YYYY hh:mm a'
                                                }
                                            }}
                                        >
                                            <input type="text" className="m-3 form-control" name="daterange" />
                                        </DateRangePicker>

                                    </div>
                                </div>
                            </div>

                            <div className="p-2">
                                <Accordion activeKey={accordionActiveKey} >
                                    {axisInfo.map((info) => renderAxisCard(info.id))}
                                    <Card></Card>
                                </Accordion>
                            </div>

                            <div className="p-2 d-flex justify-content-between">
                                <Button className="btn btn-primary text-light" block onClick={addAxisClickHandler}><i className="fas fa-plus"></i>  {t("components.linecharts.dataexploration.addaxis")}</Button>
                                <Button className="btn btn-primary text-light" block onClick={createClickHandler} disabled={signals.length == 0 || axisInfo.length == 0}><i className="fas fa-chart-area"></i>  {t("components.linecharts.dataexploration.creategraph")}</Button>
                            </div>
                        </div>
                    </Modal.Body>
                </>
                :
                <>
                    <Modal.Header>
                        <h3 className="p-2 align-items-center verticalalign">{t("components.linecharts.dataexploration.customgraph")}</h3>
                        <div className="p-2">
                            <OverlayTrigger
                                placement="bottom-end"
                                delay={{ show: 250, hide: 400 }}
                                overlay={renderTooltip}
                            >
                                <Button variant="primary"><i className="fas fa-question"></i></Button>
                            </OverlayTrigger>
                        </div>
                    </Modal.Header>

                    <Modal.Body>
                        <div height="450px">
                            <div className="p-2 d-flex justify-content-between">
                                <a className="btn btn-primary text-light" onClick={backClickHander}><i className="fas fa-chevron-left"></i> {t("common.back")}</a>
                                <div>
                                    <a className="btn btn-primary text-light" onClick={resetZoom}> <i className="fas fa-search-plus"></i> {t("common.resetzoom")}</a>
                                    <>   </>
                                    <a className="btn btn-primary text-light" href={imageURL} download> <i className="fas fa-download"></i> {t("components.linecharts.dataexploration.saveasimage")}</a>
                                </div>
                            </div>
                            <div class="chart-container" style={{ position: "relative", height: "60vh", width: "65vw" }}>
                                <canvas id="customgraphcanvas"></canvas>
                            </div>
                        </div>
                    </Modal.Body>
                </>
            }

        </Modal>
    );
    
}

function CustomGraphRootElement(props) {
    const [customGraphModalShow, setCustomGraphModalShow] = useState(false);
    const { t } = useTranslation();

    return (
        <div>
            <Button variant="primary" onClick={() => setCustomGraphModalShow(true)}>
                {t("components.linecharts.dataexploration.title-button")}
            </Button >
            <CustomGraphModal
                show={customGraphModalShow}
                onHide={() => setCustomGraphModalShow(false)}
                key={props.siteGUID}
                siteGUID={props.siteGUID}
            />
        </div>
    )
}


export default CustomGraphRootElement;
